import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '@progress/kendo-angular-dialog';
import { ConstantsService } from '../../fidelidade/ConstantsService';
import { CartaoClienteService } from '../../services/cartao-cliente.service';
import { NovoCartaoClienteComponent } from '../novo-cartao-cliente/novo-cartao-cliente.component';
const QRCode = require('qrcode');

const LIMITE_GERACAO_LOTE = 100;

export class CartaoCliente {
  id: number;
  codigo: string;
  codigoPdv: string;
  tokenAcesso: string;
  empresa: any;
  ativo: boolean;
  dataCriacao: Date;

  constructor() {
    this.ativo = true;
    this.dataCriacao = new Date();
  }
}

@Component({
  selector: 'app-cadastro-cartao-cliente',
  templateUrl: './cadastro-cartao-cliente.component.html',
  styleUrls: ['./cadastro-cartao-cliente.component.scss']
})
export class CadastroCartaoClienteComponent implements OnInit {
  loading: boolean = true;
  empresa: any;
  objetos: Array<CartaoCliente> = [];
  modalDeletar = false;
  modalGerarLote = false;
  objetoApagar: CartaoCliente;
  filtro = '';
  msgSucesso = '';
  quantidadeGeracao = 10;
  gerandoLote = false;
  mensagemErroGeracao = '';
  qrCodesPorCodigo: {[codigo: string]: string} = {};

  constructor(
    private router: Router,
    private constantsService: ConstantsService,
    private cartaoClienteService: CartaoClienteService,
    private dialogService: DialogService
  ) {
    this.constantsService.empresa$.subscribe((empresa) => {
      if (!empresa) return;
      this.empresa = empresa;
      this.carregueCartoes();
    });
  }

  ngOnInit() {}

  get cartoesFiltrados(): CartaoCliente[] {
    const filtroNormalizado = this.normalizarTexto(this.filtro);

    if (!filtroNormalizado) {
      return this.objetos || [];
    }

    return (this.objetos || []).filter((cartao: CartaoCliente) => {
      const camposBusca = [
        cartao?.codigo,
        cartao?.codigoPdv,
        cartao?.ativo ? 'ativo' : 'inativo'
      ];

      return camposBusca.some((campo) => this.normalizarTexto(campo).includes(filtroNormalizado));
    });
  }

  get quantidadeCartoesExibidos(): number {
    return this.cartoesFiltrados.length;
  }

  get quantidadeTotalCartoes(): number {
    return (this.objetos || []).length;
  }

  editar(cartao: CartaoCliente) {
    const altura = window.innerHeight - 100;
    const windowRef = this.dialogService.open({
      title: 'Editar Cartão Cliente',
      content: NovoCartaoClienteComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: altura
    });

    const telaNovoCartao = windowRef.content.instance;
    telaNovoCartao.empresa = this.empresa;
    telaNovoCartao.windowRef = windowRef;
    telaNovoCartao.cartao = Object.assign({}, cartao);

    windowRef.result.subscribe(() => {
      this.carregueCartoes();
    });
  }

  abraDialogRemover(cartao: CartaoCliente) {
    this.objetoApagar = cartao;
    this.modalDeletar = true;
  }

  onFilter($event: Event) {
    // Implementar filtro se necessário
  }

  trackByCartao(index: number, cartao: CartaoCliente): number | string {
    return cartao?.id || cartao?.codigo || index;
  }

  abrirDialogGerarLote() {
    this.quantidadeGeracao = 10;
    this.mensagemErroGeracao = '';
    this.modalGerarLote = true;
  }

  novo() {
    const altura = window.innerHeight - 100;
    const windowRef = this.dialogService.open({
      title: 'Novo Cartão Cliente',
      content: NovoCartaoClienteComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: altura
    });

    const telaNovoCartao = windowRef.content.instance;
    telaNovoCartao.empresa = this.empresa;
    telaNovoCartao.windowRef = windowRef;

    windowRef.result.subscribe(() => {
      this.carregueCartoes();
    });
  }

  close(status: string) {
    if (status === 'sim') {
      this.cartaoClienteService.removaCartao(this.objetoApagar.id).then(() => {
        this.objetoApagar = null;
        this.modalDeletar = false;
        this.carregueCartoes();
      });
    } else {
      this.objetoApagar = null;
      this.modalDeletar = false;
    }
  }

  closeGerarLote() {
    if (this.gerandoLote) {
      return;
    }

    this.modalGerarLote = false;
    this.mensagemErroGeracao = '';
  }

  gerarLote() {
    const quantidade = Number(this.quantidadeGeracao);

    if (!Number.isInteger(quantidade) || quantidade <= 0) {
      this.mensagemErroGeracao = 'Informe uma quantidade válida para geração.';
      return;
    }

    if (quantidade > LIMITE_GERACAO_LOTE) {
      this.mensagemErroGeracao = `O limite por geração é de ${LIMITE_GERACAO_LOTE} cartões.`;
      return;
    }

    this.gerandoLote = true;
    this.mensagemErroGeracao = '';

    this.cartaoClienteService.gereLoteCartoes(quantidade).then((retorno: any) => {
      const quantidadeGerada = retorno?.quantidadeGerada || 0;
      const primeiroCodigo = retorno?.primeiroCodigo;
      const ultimoCodigo = retorno?.ultimoCodigo;

      this.msgSucesso = quantidadeGerada > 0 && primeiroCodigo && ultimoCodigo ?
        `Foram gerados ${quantidadeGerada} cartões, do código ${primeiroCodigo} ao ${ultimoCodigo}.` :
        'Os cartões foram gerados com sucesso.';

      this.modalGerarLote = false;
      this.gerandoLote = false;
      this.carregueCartoes();
    }).catch((erro) => {
      this.gerandoLote = false;
      this.mensagemErroGeracao = erro || 'Não foi possível gerar os cartões agora.';
    });
  }

  voltar() {
    this.router.navigate(['/admin/pedidos-mesas'])
      .then(() => {})
      .catch(err => console.error('Erro ao navegar:', err));
  }

  private carregueCartoes() {
    this.cartaoClienteService.obtenhaCartoes().then((cartoes: any) => {
      this.objetos = this.ordeneCartoes(cartoes || []);
      this.prepararQrCodes(this.objetos || []);
      this.loading = false;
    }).catch((erro) => {
      this.loading = false;
    });
  }

  obtenhaQrCode(cartao: CartaoCliente): string {
    const token = this.normalizarCodigo(cartao?.tokenAcesso);
    if (!token) {
      return '';
    }

    return this.qrCodesPorCodigo[token] || this.obtenhaUrlQrCode(cartao);
  }

  obtenhaUrlQrCode(cartao: CartaoCliente): string {
    const linkCartao = this.obtenhaLinkCartao(cartao);
    if (!linkCartao) {
      return '';
    }

    return `/qrcode/${encodeURIComponent(linkCartao)}`;
  }

  private async prepararQrCodes(cartoes: CartaoCliente[]) {
    const entradas = await Promise.all((cartoes || []).map(async (cartao) => {
      const token = this.normalizarCodigo(cartao?.tokenAcesso);
      const linkCartao = this.obtenhaLinkCartao(cartao);
      if (!token || !linkCartao) {
        return null;
      }

      try {
        const dataUrl = await QRCode.toDataURL(linkCartao, {
          width: 220,
          margin: 1
        });
        return [token, dataUrl];
      } catch (erro) {
        console.error('Erro ao gerar QR Code do cartão cliente', erro);
        return [token, this.obtenhaUrlQrCode(cartao)];
      }
    }));

    this.qrCodesPorCodigo = (entradas || []).reduce((acc: {[codigo: string]: string}, entrada: any) => {
      if (entrada && entrada[0] && entrada[1]) {
        acc[entrada[0]] = entrada[1];
      }
      return acc;
    }, {});
  }

  obtenhaLinkCartao(cartao: CartaoCliente): string {
    const linkLoja = String(this.empresa?.linkLoja || '').replace(/\/$/, '');
    const token = this.normalizarCodigo(cartao?.tokenAcesso);
    return linkLoja && token ? `${linkLoja}/comanda/${token}` : '';
  }

  private normalizarCodigo(codigo: any): string {
    return String(codigo || '').trim();
  }

  private normalizarTexto(valor: any): string {
    return String(valor || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  private ordeneCartoes(cartoes: CartaoCliente[]): CartaoCliente[] {
    return [...(cartoes || [])].sort((cartaoA: CartaoCliente, cartaoB: CartaoCliente) => {
      const codigoA = this.normalizarCodigo(cartaoA?.codigo);
      const codigoB = this.normalizarCodigo(cartaoB?.codigo);
      const codigoANumerico = /^\d+$/.test(codigoA);
      const codigoBNumerico = /^\d+$/.test(codigoB);

      if (codigoANumerico && codigoBNumerico) {
        return Number(codigoA) - Number(codigoB);
      }

      if (codigoANumerico) {
        return -1;
      }

      if (codigoBNumerico) {
        return 1;
      }

      return codigoA.localeCompare(codigoB, 'pt-BR', { numeric: true, sensitivity: 'base' });
    });
  }
}
